import { gql } from '@apollo/client'

export const INSIGHT_FRAGMENT = gql`
  fragment Insight on Insight {
    id
    message
    insightType
    snoozedUntil
    resolutionDate
    store {
      id
    }
    notes {
      id
      note
    }
  }
`
